import React from 'react'

export default function ErrorCriticalStaff() {
  return (
    <div className="ob-error">
      <h1 className="zb-heading2">Sorry, something went wrong</h1>
      <div className="zb-card">
        <div className="zb-card-body">
          An unexpected error has occurred. Please get in touch with your
          administrator.
        </div>
      </div>
    </div>
  )
}
